export default ({
  data: { blocks, order, success, updatedAt, warning }
}) => {
  if (!success) {
    return {
      editorHeaderStatus: 'importError',
      editorImportVisible: false,
      editorIsImporting: false
    };
  }

  return {
    editorAdders: [false, ...order.map(() => false)],
    editorBlocks: blocks,
    editorBlocksOrder: order,
    editorHeaderStatus: warning ? 'importWarning' : 'importSuccess',
    editorHeaderUpdatedAt: updatedAt,
    editorImportVisible: false,
    editorIsDisabled: false,
    editorIsDraft: true,
    editorIsImporting: false
  };
};
